function fileUploadDirective() {
    return {
        restrict: 'A',
        scope: {
            fileReader: "=",
            fileName: "=",
            changed: "&?",
            readBinary: "<?"
        },
        link: function(scope, element) {
            var handleFiles = function (event) {
                let files = event.target.files;
                if (files.length) {
                    let r = new FileReader();
                    r.onload = function(e) {
                        let contents = e.target.result;
                        scope.$apply(function () {
                            scope.fileName.content = files[0].name;
                            scope.fileReader.content = contents;
                        });
                    };
                    scope.readBinary ? r.readAsArrayBuffer(files[0]) : r.readAsText(files[0]);
                }
            };
            element.on('click', function (event) {
                if(angular.isDefined(scope.fileName.content) || angular.isDefined(scope.fileReader.content)) {
                    handleFiles(event);
                }
            });
            element.on('change', function(changeEvent) {
                handleFiles(changeEvent);
                scope.changed();
            });
        }

    }
}

fileUploadDirective.$inject = [];

module.exports = fileUploadDirective;


// WEBPACK FOOTER //
// ./src/shared/fileUpload/fileUpload.directive.js